import { useMutation } from '@biletiniz/apollo';
import { LOGIN } from './gql/login';

export const useLogin = () => {
  const [loginMutation, { loading, error }] = useMutation(LOGIN);

  const login = loginInfo => {
    return loginMutation({
      variables: loginInfo,
    });
  };

  const initialValues = {
    password: '',
    email: '',
    phoneNumber: '90 ',
    verifyPhone: true,
  };

  return {
    error: error?.message,
    login,
    loading,
    initialValues,
  };
};
